import PropTypes from 'prop-types';
import React from 'react';
import LoadingPlaceholderFullPage from 'components/shared/LoadingPlaceholderFullPage';
import useTextPromptAnswersForActivity from 'api-new/stim-based/useTextPromptAnswersForActivity';
import { TextPromptActivityResponsesIndicator as RCTextPromptActivityResponsesIndicator } from '@visionslive/reporting-components';

const TextPromptActivityResponsesIndicator = ({ activityId }) => {
    const { data: responses, isLoading: isLoadingTextPromptAnswers } = useTextPromptAnswersForActivity({ activityId });

    if (isLoadingTextPromptAnswers) {
        return <LoadingPlaceholderFullPage />;
    }

    return (
        <RCTextPromptActivityResponsesIndicator
            responses={responses}
            sx={{
                height: 35
            }}
        />
    );
};

TextPromptActivityResponsesIndicator.propTypes = {
    activityId: PropTypes.string
};

export default TextPromptActivityResponsesIndicator;
